import type {SetOptional} from 'type-fest'

export interface RawMessage {
  id: string
  content: string
  author: string
  thread_id: string
  username: string
  creation_time: string
  action: 'like' | 'dislike' | null
}

export interface Message extends Omit<RawMessage, 'author' | 'creation_time' | 'thread_id'> {
  author: 'user' | 'assistant'
  threadId: string
  creationTime: Date
}

export type MinimalMessage = SetOptional<
  Message,
  'threadId' | 'creationTime' | 'id' | 'username' | 'action'
>

export function transformMessage(raw: RawMessage): Message {
  return {
    id: raw.id,
    content: raw.content,
    author: raw.author === 'user' ? 'user' : 'assistant',
    username: raw.username,
    threadId: raw.thread_id,
    creationTime: new Date(raw.creation_time),
    action: raw.action,
  }
}

export function transformMessages(raws: RawMessage[]): Message[] {
  return raws.map(transformMessage)
}
